"use client";

import { BrandXMark } from "@/components/icons/SiteMarks";
import { SideStoryFacts } from "@/components/sections/story/SideStoryFacts";
import { SideTickList } from "@/components/site/SideTickList";
import { useContent } from "@/components/site/ContentProvider";
import { officePhoneHref } from "@/lib/whatsapp";

function SideNavSelector() {
  return (
    <div className="side_nav_selector side_aspect f a-c s-b">
      <BrandXMark className="side_nav_x" />
      <BrandXMark className="side_nav_x" />
    </div>
  );
}

/** Wordmark in the products side-nav (replaces AutoConnect / Property Central SVGs). */
function ProductSideMark({ name }: { name: string }) {
  return (
    <span className="product_side_mark" aria-hidden>
      {name}
    </span>
  );
}

export function SideRight() {
  const site = useContent();
  return (
    <div className="side_wrap side_right f a-c desktop">
      <div className="side_nav" id="side-nav-work">
        <SideNavSelector />
        <div className="side_nav_set f f-c">
          {site.projects.map((project) => (
            <div
              className="side_nav_item side_aspect scrollTo"
              data-scroll={project.slide}
              data-margin="0.5"
              key={project.id}
            >
              <div className="side_block">
                <i
                  className="side_img cover load_bg"
                  data-src={project.cover}
                  role="img"
                  aria-label={project.coverAlt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="side_nav" id="side-nav-products">
        <SideNavSelector />
        <div className="side_nav_set f f-c">
          {site.products.map((product, i) => (
            <div
              className="side_nav_item side_aspect scrollTo"
              data-scroll={i === 0 ? "productsTrigger" : "products-end"}
              id={`side-p-${i + 1}`}
              key={product.id}
            >
              <div className="side_block">
                <ProductSideMark name={product.name} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {site.services.map((service, i) => (
        <div
          className={`side_container f a-c j-e side-service-${i + 1}`}
          key={`svc-right-${service.name}`}
        >
          <div className="side_mdl">
            <SideTickList title={site.labels.subservices} items={service.subservices} />
          </div>
        </div>
      ))}

      <div className="side_container f a-c j-e side-story">
        <div className="side_top">
          <SideStoryFacts />
        </div>
      </div>

      <div className="side_container f a-c j-e side-contact">
        <div className="side_top">
          <div className="contact_blocks f f-c">
            {site.offices.map((office) => (
              <div className="contact_block f f-c" key={office.code}>
                <span className="uppercase _ele ltr_island" dir="ltr">
                  {office.code}
                </span>
                <div className="contact_list f f-c a-s">
                  {office.phones.map((phone) => (
                    <a
                      key={phone.href}
                      href={officePhoneHref(phone, site.contact.whatsappMessage)}
                      className="_underline small label _ele ltr_island"
                      dir="ltr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {phone.label}
                    </a>
                  ))}
                  <a
                    href={`mailto:${office.email}`}
                    className="_underline small label _ele ltr_island"
                    dir="ltr"
                    target="_blank"
                  >
                    {office.email}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
